<template>
  <div>
    <div v-if="is_h5 === false" class="pc-page-root">
      <pheader activeIndex="CourseMajorDisplay" />
        <el-container class="pc_index_main">
          <el-main>
            <div class="pc_index_main-0">
              <div class="col-content page-inner ibp-major-content-shell">
                <div ref="toolbarCardRef" class="toolbar-card">
                  <div class="toolbar-card__intro">
                    <span class="toolbar-card__label">查找专业</span>
                    <span v-if="total > 0" class="toolbar-card__hint"
                      >已加载全部数据；右侧默认显示第一个学院，点击左侧「学院导航」切换</span
                    >
                  </div>
                  <el-input
                    v-model="keyword"
                    clearable
                    placeholder="输入学院或专业名称，回车搜索"
                    class="search-input"
                    size="large"
                    @clear="handleSearch"
                    @keyup.enter="handleSearch"
                  >
                    <template #prefix>
                      <el-icon class="search-ico"><Search /></el-icon>
                    </template>
                    <template #append>
                      <el-button type="primary" @click="handleSearch">搜索</el-button>
                    </template>
                  </el-input>
                </div>

                <div class="catalog-layout">
                  <!-- 占位列保留布局宽度；导航本体 fixed 在视口内，便于随时点击跳转 -->
                  <div v-if="groupedMajors.length > 1" ref="tocColumnRef" class="catalog-toc-column">
                    <aside
                      ref="tocAsideRef"
                      class="catalog-toc"
                      :style="tocFixedAsideStyle"
                      aria-label="学院导航"
                    >
                      <div class="catalog-toc__title">学院导航</div>
                      <nav class="catalog-toc__nav">
                        <button
                          v-for="(group, idx) in groupedMajors"
                          :key="'toc-' + group.college"
                          type="button"
                          class="catalog-toc__link"
                          :class="{ 'catalog-toc__link--active': idx === activeCollegeIndex }"
                          @click="selectCollege(idx)"
                        >
                          <span class="catalog-toc__idx">{{ idx + 1 }}</span>
                          <span class="catalog-toc__text">{{ group.college }}</span>
                          <span class="catalog-toc__n">{{ group.items.length }}</span>
                        </button>
                      </nav>
                    </aside>
                  </div>

                  <div
                    v-loading="loading"
                    class="catalog-main"
                    :style="catalogMainMinStyle"
                    element-loading-custom-class="major-catalog-loading"
                  >
                    <template v-if="activeCollegeGroup">
                      <section
                        :id="'majors-anchor-' + activeCollegeIndex"
                        class="college-section"
                        :class="{ 'college-section--alt': activeCollegeIndex % 2 === 1 }"
                      >
                        <div class="college-section__head">
                          <span class="college-section__badge">{{ activeCollegeIndex + 1 }}</span>
                          <span class="college-section__bar" aria-hidden="true" />
                          <h2 class="college-section__title">{{ activeCollegeGroup.college }}</h2>
                          <el-tag type="info" effect="plain" round size="small"
                            >{{ activeCollegeGroup.items.length }} 个专业</el-tag
                          >
                        </div>
                        <div class="card-grid">
                          <article
                            v-for="item in activeCollegeGroup.items"
                            :key="item._id"
                            class="major-card major-card--clickable major-card--rich"
                            role="button"
                            tabindex="0"
                            @click="openMajorDetail(item)"
                            @keydown.enter="openMajorDetail(item)"
                          >
                            <div class="major-card__shine" aria-hidden="true" />
                            <div class="major-card__deco" aria-hidden="true" />
                            <div class="major-card__body">
                              <div class="major-card__avatar" aria-hidden="true">
                                {{ majorInitial(item) }}
                              </div>
                              <div class="major-card__text">
                                <h3 class="major-card__name" :title="item.major_name">
                                  {{ item.major_name || '—' }}
                                </h3>
                                <p class="major-card__tagline">培养方案 · 课程资源</p>
                              </div>
                            </div>
                            <div class="major-card__foot">
                              <span class="major-card__foot-hint">查看详情</span>
                              <span class="major-card__foot-arrow">
                                <el-icon><ArrowRight /></el-icon>
                              </span>
                            </div>
                          </article>
                        </div>
                      </section>
                    </template>
                    <div v-else-if="!loading" class="catalog-main__empty-wrap">
                      <el-empty description="暂无专业数据，试试调整搜索条件" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-main>
        </el-container>
      <pfooter></pfooter>
    </div>

    <div v-else class="h5-wrap">
      <pheader activeIndex="CourseMajorDisplay" />
      <div class="h5-search">
        <van-search
          v-model="keyword"
          placeholder="学院或专业名"
          @search="handleSearch"
          @clear="handleSearch"
        />
      </div>
      <div v-if="groupedMajors.length > 1" class="h5-chips-wrap">
        <div class="h5-chips">
          <button
            v-for="(group, idx) in groupedMajors"
            :key="'h5toc-' + group.college"
            type="button"
            class="h5-chip"
            :class="{ 'h5-chip--active': idx === activeCollegeIndex }"
            @click="selectCollege(idx)"
          >
            {{ idx + 1 }}. {{ shortCollegeName(group.college) }}
          </button>
        </div>
      </div>
      <div
        v-loading="loading"
        class="h5-body"
        element-loading-custom-class="major-h5-loading"
      >
        <template v-if="activeCollegeGroup">
          <div :id="'h5-anchor-' + activeCollegeIndex" class="h5-college-block">
            <div class="h5-college-title">
              <span class="h5-college-num">{{ activeCollegeIndex + 1 }}</span>
              {{ activeCollegeGroup.college }}
            </div>
            <div
              v-for="item in activeCollegeGroup.items"
              :key="item._id"
              class="h5-major-card h5-major-card--clickable h5-major-card--rich"
              role="button"
              tabindex="0"
              @click="openMajorDetail(item)"
            >
              <div class="h5-major-card__avatar" aria-hidden="true">{{ majorInitial(item) }}</div>
              <div class="h5-major-card__main">
                <div class="h5-major-name">{{ item.major_name || '—' }}</div>
                <div class="h5-major-tagline">培养方案 · 课程资源</div>
              </div>
              <div class="h5-major-card__cta">
                <el-icon><ArrowRight /></el-icon>
              </div>
            </div>
          </div>
        </template>
        <div v-else-if="!loading" class="h5-body__empty-wrap">
          <van-empty description="暂无专业数据" />
        </div>
      </div>
      <pfooter></pfooter>
    </div>

    <major-catalog-login-dialog
      v-model="loginDialogVisible"
      @success="onMajorCatalogLoginSuccess"
    />
    <ai-search-component :isisShow="isisShow"></ai-search-component>
    <div
      class="ibp-h5-ai-fab"
      role="button"
      tabindex="0"
      aria-label="打开课程助手"
      @click="clickAIButton($event)"
      @keydown.enter.prevent="clickAIButton($event)"
    >
      <div class="ibp-h5-ai-fab__inner">
        <el-image class="ibp-h5-ai-fab__img" fit="contain" :src="require('@/assets/hcvt.png')" />
        <p class="ibp-h5-ai-fab__label">课程助手</p>
      </div>
    </div>
  </div>
</template>

<script>
import { ArrowRight, Search } from '@element-plus/icons-vue'
import { showNotify } from 'vant'
import {
  isMajorCatalogLoginOk,
  isMajorDetailLoginRequired,
  setMajorCatalogLoginOk,
} from '@/common/js/majorCatalogSession'
import pheader from '@/views/pheader.vue'
import pfooter from '@/views/pfooter.vue'
import aiSearchComponent from '@/components/ai-search-component.vue'
import MajorCatalogLoginDialog from '@/components/major-catalog-login-dialog.vue'

/** 从专业详情返回目录时恢复「学院导航」选中项（与当前搜索关键词绑定） */
const MAJOR_CATALOG_CTX_KEY = 'ibp_major_catalog_context_v1'

export default {
  name: 'CourseMajorDisplay',
  components: {
    pheader,
    pfooter,
    aiSearchComponent,
    MajorCatalogLoginDialog,
    Search,
    ArrowRight,
  },
  data() {
    return {
      is_h5: this.$utils.checkScreenSize(),
      loading: false,
      keyword: '',
      tableData: [],
      total: 0,
      isisShow: 0,
      apiUrl: '/courseMajorApp/loadCourseMajorListForDisplay',
      /** 宽屏下学院导航 position:fixed 的内联坐标（与占位列对齐） */
      tocFixedAsideStyle: {},
      /** 右侧当前展示的学院分组索引，默认 0（第一个） */
      activeCollegeIndex: 0,
      /**
       * 左侧导航为 position:fixed 时左侧列不占文档高度，右侧会变矮；
       * 用与左侧 aside 等高的 min-height 对齐右侧区域底边与导航底边。
       */
      catalogMainMinStyle: {},
      /** 点击专业前需登录：与后台 login.html 同源（账号+验证码+钉钉） */
      loginDialogVisible: false,
      pendingMajorAfterLogin: null,
    }
  },
  computed: {
    /** 当前选中的学院及其专业列表（右侧仅渲染这一块） */
    activeCollegeGroup() {
      const list = this.groupedMajors
      if (!list || !list.length) return null
      const i = Math.min(Math.max(0, this.activeCollegeIndex), list.length - 1)
      return list[i]
    },
    groupedMajors() {
      const rows = this.tableData || []
      const map = {}
      for (const row of rows) {
        const c = (row.college && String(row.college).trim()) || '其他'
        if (!map[c]) map[c] = []
        map[c].push(row)
      }
      const keys = Object.keys(map).sort((a, b) => a.localeCompare(b, 'zh-Hans-CN'))
      return keys.map((college) => ({ college, items: map[college] }))
    },
    collegeCount() {
      return this.groupedMajors.length
    },
  },
  mounted() {
    window.addEventListener('resize', this.windowResize)
    window.addEventListener('scroll', this.handleWindowScrollForToc, { passive: true })
    this.loadData()
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.windowResize)
    window.removeEventListener('scroll', this.handleWindowScrollForToc)
    if (this._tocScrollRaf != null) {
      cancelAnimationFrame(this._tocScrollRaf)
      this._tocScrollRaf = null
    }
    this.unbindTocObserver()
    this.unbindTocAsideHeightObserver()
  },
  methods: {
    isDesktopTocFixed() {
      return !this.is_h5 && window.innerWidth > 960
    },
    /**
     * 「查找专业」与视口相交时：导航 top 与左侧占位列对齐（视觉上紧贴搜索区下方）。
     * 搜索区完全滚出视口上方后：导航顶边固定为 16px。
     */
    updateTocFixedPosition() {
      if (!this.isDesktopTocFixed() || this.groupedMajors.length <= 1) {
        this.tocFixedAsideStyle = {}
        this.catalogMainMinStyle = {}
        this.unbindTocObserver()
        this.unbindTocAsideHeightObserver()
        return
      }
      this.$nextTick(() => {
        this.applyTocFixedPosition()
      })
    },
    applyTocFixedPosition() {
      if (!this.isDesktopTocFixed() || this.groupedMajors.length <= 1) {
        this.tocFixedAsideStyle = {}
        this.catalogMainMinStyle = {}
        return
      }
      const col = this.$refs.tocColumnRef
      if (!col) {
        this.tocFixedAsideStyle = {}
        this.catalogMainMinStyle = {}
        return
      }
      const colRect = col.getBoundingClientRect()
      const w = Math.round(colRect.width) || 220
      const left = Math.max(0, colRect.left)
      const toolbar = this.$refs.toolbarCardRef
      const toolbarRect = toolbar ? toolbar.getBoundingClientRect() : null
      const vh = window.innerHeight
      const toolbarInView =
        toolbarRect &&
        toolbarRect.bottom > 0 &&
        toolbarRect.top < vh
      let topPx
      if (toolbarInView) {
        topPx = Math.max(12, Math.round(colRect.top))
      } else {
        topPx = 16
      }
      const maxH = Math.max(160, Math.round(vh - topPx - 16))
      this.tocFixedAsideStyle = {
        position: 'fixed',
        left: `${left}px`,
        top: `${topPx}px`,
        width: `${w}px`,
        maxHeight: `${maxH}px`,
        zIndex: '35',
        boxSizing: 'border-box',
        overflow: 'auto',
      }
      this.$nextTick(() => {
        this.syncCatalogMainMinHeight()
      })
    },
    /** 右侧主栏至少与左侧固定导航同高，避免专业仅一行时整块「缩上去」 */
    syncCatalogMainMinHeight() {
      if (!this.isDesktopTocFixed() || this.groupedMajors.length <= 1) {
        this.catalogMainMinStyle = {}
        return
      }
      const aside = this.$refs.tocAsideRef
      if (!aside) {
        this.catalogMainMinStyle = {}
        return
      }
      const h = Math.round(aside.getBoundingClientRect().height)
      if (h > 0) {
        this.catalogMainMinStyle = { minHeight: `${h}px` }
      }
    },
    bindTocAsideHeightObserver() {
      this.unbindTocAsideHeightObserver()
      if (this.groupedMajors.length <= 1) return
      const aside = this.$refs.tocAsideRef
      if (!aside || typeof ResizeObserver === 'undefined') return
      this._tocAsideHeightObs = new ResizeObserver(() => {
        this.syncCatalogMainMinHeight()
      })
      this._tocAsideHeightObs.observe(aside)
    },
    unbindTocAsideHeightObserver() {
      if (this._tocAsideHeightObs) {
        this._tocAsideHeightObs.disconnect()
        this._tocAsideHeightObs = null
      }
    },
    handleWindowScrollForToc() {
      if (!this.isDesktopTocFixed() || this.groupedMajors.length <= 1) return
      if (this._tocScrollRaf != null) return
      this._tocScrollRaf = requestAnimationFrame(() => {
        this._tocScrollRaf = null
        this.applyTocFixedPosition()
      })
    },
    bindTocObserver() {
      this.unbindTocObserver()
      if (this.groupedMajors.length <= 1) return
      const el = this.$refs.tocColumnRef
      if (!el || typeof ResizeObserver === 'undefined') return
      this._tocResizeObs = new ResizeObserver(() => {
        this.applyTocFixedPosition()
      })
      this._tocResizeObs.observe(el)
      this.bindTocAsideHeightObserver()
    },
    unbindTocObserver() {
      if (this._tocResizeObs) {
        this._tocResizeObs.disconnect()
        this._tocResizeObs = null
      }
    },
    windowResize() {
      this.is_h5 = this.$utils.checkScreenSize()
      this.updateTocFixedPosition()
    },
    shortCollegeName(name) {
      const s = String(name || '')
      return s.length > 8 ? s.slice(0, 8) + '…' : s
    },
    /** 卡片头像：取专业名称首字，增强辨识度 */
    majorInitial(item) {
      const n = item && item.major_name != null ? String(item.major_name).trim() : ''
      if (!n) return '专'
      return n.charAt(0)
    },
    selectCollege(idx) {
      const n = this.groupedMajors.length
      if (n < 1 || idx < 0 || idx >= n) return
      this.activeCollegeIndex = idx
      this.persistCatalogCollegeContext()
    },
    clickAIButton() {
      this.isisShow += 1
    },
    handleSearch() {
      this.loadData()
    },
    openMajorDetail(item) {
      if (isMajorDetailLoginRequired() && !isMajorCatalogLoginOk()) {
        this.pendingMajorAfterLogin = item
        this.loginDialogVisible = true
        return
      }
      this.navigateToMajorDetail(item)
    },
    onMajorCatalogLoginSuccess() {
      setMajorCatalogLoginOk()
      const item = this.pendingMajorAfterLogin
      this.pendingMajorAfterLogin = null
      if (item) {
        this.navigateToMajorDetail(item)
      }
    },
    navigateToMajorDetail(item) {
      const id = item && item._id
      if (!id) {
        showNotify('缺少专业标识，无法打开详情')
        return
      }
      this.persistCatalogCollegeContext()
      this.$router.push({
        name: 'CourseMajorDetail',
        params: { majorId: String(id) },
      })
    },
    persistCatalogCollegeContext() {
      try {
        const payload = JSON.stringify({
          collegeIndex: this.activeCollegeIndex,
          keyword: this.keyword || '',
        })
        sessionStorage.setItem(MAJOR_CATALOG_CTX_KEY, payload)
      } catch (e) {
        /* ignore */
      }
    },
    /** 列表加载完成后：若存储里的关键词与当前一致，则恢复上次选中的学院索引 */
    applyCatalogCollegeRestore() {
      const maxIdx = Math.max(0, this.groupedMajors.length - 1)
      let next = 0
      try {
        const raw = sessionStorage.getItem(MAJOR_CATALOG_CTX_KEY)
        if (raw) {
          const o = JSON.parse(raw)
          const idx = Number(o.collegeIndex)
          const storedKw = o.keyword != null ? String(o.keyword) : ''
          const kw = this.keyword || ''
          if (Number.isFinite(idx) && storedKw === kw && idx >= 0 && idx <= maxIdx) {
            next = idx
          }
        }
      } catch (e) {
        next = 0
      }
      this.activeCollegeIndex = next
    },
    loadData() {
      this.loading = true
      const param = {
        isPage: false,
        keyword: this.keyword || '',
      }
      this.$http
        .post(this.apiUrl, param)
        .then((res) => {
          this.loading = false
          if (res.resultCode === '0' || res.resultCode === 0) {
            const d = res.resultData || {}
            this.tableData = d.DataList || []
            this.total = d.Total != null ? d.Total : 0
            this.applyCatalogCollegeRestore()
            this.persistCatalogCollegeContext()
            this.$nextTick(() => {
              this.updateTocFixedPosition()
              this.bindTocObserver()
            })
          } else {
            this.tableData = []
            this.total = 0
            this.tocFixedAsideStyle = {}
            this.catalogMainMinStyle = {}
            window.vueAlter(res.resultMsg || '加载失败', 'warning')
          }
        })
        .catch(() => {
          this.loading = false
          this.tableData = []
          this.tocFixedAsideStyle = {}
          this.catalogMainMinStyle = {}
          this.unbindTocObserver()
          this.unbindTocAsideHeightObserver()
          showNotify('请求失败，请稍后再试')
        })
    },
  },
  watch: {
    groupedMajors: {
      handler(list) {
        const len = list && list.length ? list.length : 0
        if (len === 0) {
          this.activeCollegeIndex = 0
        } else if (this.activeCollegeIndex >= len) {
          this.activeCollegeIndex = 0
        }
        this.persistCatalogCollegeContext()
        this.$nextTick(() => {
          this.updateTocFixedPosition()
          this.bindTocObserver()
        })
      },
    },
    activeCollegeIndex() {
      this.$nextTick(() => {
        this.syncCatalogMainMinHeight()
      })
    },
  },
}
</script>

<style scoped>
/* 与顶栏 #175cc4 同系的页面背景变量，避免头图与内容区发灰发冷 */
.pc-page-root {
  --major-nav-blue: #175cc4;
  --major-page-bg: #e8f1fb;
  --major-page-bg-mid: #eef4fb;
  --major-page-bg-soft: #f4f8fc;
  overflow-x: hidden;
  min-height: 100vh;
  background-color: var(--major-page-bg-soft);
}

.pc_index-banner {
  /* 顶栏同色起笔，向下略提亮，与导航条无缝衔接 */
  background: linear-gradient(
    165deg,
    var(--major-nav-blue) 0%,
    #1a6bcf 38%,
    #2d7fd8 72%,
    #4a9ae8 100%
  );
  color: #fff;
  position: relative;
  overflow: hidden;
  padding-bottom: 0;
}

.pc_index-banner::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(ellipse 85% 65% at 88% -15%, rgba(255, 255, 255, 0.2), transparent 52%),
    radial-gradient(ellipse 55% 45% at 5% 105%, rgba(255, 255, 255, 0.08), transparent 48%);
  pointer-events: none;
}

.banner-inner {
  max-width: var(--ibp-major-content-max-width);
  margin: 0 auto;
  padding: 42px 12px 20px;
  text-align: center;
  position: relative;
  z-index: 1;
}

@media screen and (max-width: 1400px) {
  .banner-inner {
    max-width: 100%;
  }
}

.banner-eyebrow {
  margin: 0 0 10px;
  font-size: 12px;
  letter-spacing: 0.35em;
  text-transform: uppercase;
  opacity: 0.75;
  font-weight: 500;
}

.banner-title {
  margin: 0;
  font-size: 32px;
  font-weight: 800;
  letter-spacing: 4px;
  text-shadow: 0 2px 24px rgba(0, 0, 0, 0.12);
}

.banner-sub {
  margin: 14px auto 0;
  max-width: 520px;
  font-size: 15px;
  opacity: 0.92;
  font-weight: 400;
  line-height: 1.55;
}

.banner-stats {
  margin-top: 22px;
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

.banner-stat-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 18px;
  border-radius: 999px;
  font-size: 14px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.22);
  backdrop-filter: blur(6px);
}

.banner-stat-pill--accent {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.35);
}

.banner-stat-pill em {
  font-style: normal;
  font-size: 20px;
  font-weight: 800;
}

.banner-wave {
  line-height: 0;
  margin-top: 8px;
}

.banner-wave svg {
  display: block;
  width: 100%;
  height: 44px;
}

.pc_index_main-0 {
  margin-top: 0;
  background: linear-gradient(
    180deg,
    var(--major-page-bg) 0%,
    var(--major-page-bg-mid) 42%,
    var(--major-page-bg-soft) 100%
  );
  padding-bottom: 48px;
}

.page-inner {
  padding-top: 8px;
  padding-bottom: 8px;
}

.toolbar-card {
  background: linear-gradient(180deg, #ffffff 0%, #fafcff 100%);
  border-radius: 16px;
  padding: 20px 22px 22px;
  box-shadow: 0 8px 36px rgba(23, 92, 196, 0.1);
  margin-bottom: 24px;
  border: 1px solid rgba(23, 92, 196, 0.1);
}

.toolbar-card__intro {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
  flex-wrap: wrap;
}

.toolbar-card__label {
  font-size: 17px;
  font-weight: 700;
  color: #303133;
}

.toolbar-card__hint {
  font-size: 13px;
  color: #909399;
  line-height: 1.5;
}

.search-input {
  max-width: 100%;
}

.search-ico {
  color: #909399;
}

/* Grid：左右两格强制与最高列同高，左侧整格作为 sticky 的参照轨道（比 flex+stretch 更稳） */
.catalog-layout {
  display: grid;
  grid-template-columns: minmax(0, 240px) minmax(0, 1fr);
  gap: 24px;
  align-items: stretch;
}

.catalog-toc-column {
  min-width: 0;
  min-height: 0;
  align-self: stretch;
}

/* 宽屏：定位由脚本 inline 设为 fixed；此处只保留外观 */
.catalog-toc {
  overflow: auto;
  padding: 14px 12px;
  background: #fff;
  border-radius: 14px;
  border: 1px solid rgba(23, 92, 196, 0.08);
  box-shadow: 0 4px 24px rgba(23, 92, 196, 0.12);
  -webkit-overflow-scrolling: touch;
}

.catalog-toc__title {
  font-size: 13px;
  font-weight: 700;
  color: #909399;
  letter-spacing: 0.12em;
  margin-bottom: 10px;
  padding: 0 4px;
}

.catalog-toc__nav {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.catalog-toc__link {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 10px 9px;
  border: none;
  border-radius: 10px;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font-size: 15px;
  color: #303133;
  transition: background 0.15s ease, color 0.15s ease;
}

.catalog-toc__link:hover {
  background: #f0f6ff;
}

.catalog-toc__link--active {
  background: #e8f1fc;
  color: #175cc4;
  font-weight: 600;
}

.catalog-toc__link--active:hover {
  background: #dceaf9;
}

.catalog-toc__idx {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  font-size: 12px;
  font-weight: 700;
  color: #175cc4;
  background: #e8f1fc;
  border-radius: 6px;
}

.catalog-toc__link--active .catalog-toc__idx {
  background: #175cc4;
  color: #fff;
}

.catalog-toc__text {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.catalog-toc__n {
  flex-shrink: 0;
  font-size: 12px;
  color: #909399;
}

.catalog-main {
  min-width: 0;
  min-height: 280px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

/* 与 catalogMainMinStyle 配合：专业少时仍铺满与左侧导航等高的区域 */
.catalog-main > .college-section {
  flex: 1 1 auto;
  min-height: 100%;
  margin-bottom: 0;
}

.catalog-main__empty-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 260px;
  width: 100%;
  box-sizing: border-box;
  padding: 24px 12px 32px;
}

.catalog-main__empty-wrap :deep(.el-empty) {
  margin: 0 auto;
}

/* 避免父级 overflow 裁剪 sticky；与本页 Grid 布局配合 */
.pc-page-root .pc_index_main,
.pc-page-root .pc_index_main-0,
.pc-page-root .col-content,
.pc-page-root .el-container,
.pc-page-root .el-main {
  overflow: visible;
}

@media screen and (max-width: 960px) {
  .catalog-layout {
    grid-template-columns: 1fr;
  }

  .catalog-toc-column {
    max-width: none;
    width: 100%;
  }

  .catalog-toc {
    position: sticky;
    top: 0;
    z-index: 20;
    max-height: none;
    width: 100%;
    padding-bottom: 12px;
    box-shadow: 0 4px 20px rgba(23, 92, 196, 0.06);
  }

  .catalog-toc__nav {
    flex-direction: row;
    flex-wrap: wrap;
  }

  .catalog-toc__link {
    width: auto;
    flex: 1 1 40%;
  }
}

.college-section {
  margin-bottom: 32px;
  scroll-margin-top: 20px;
  padding: 20px 20px 8px;
  border-radius: 16px;
}

.college-section--alt {
  background: rgba(255, 255, 255, 0.72);
  box-shadow: inset 0 1px 0 rgba(23, 92, 196, 0.06);
}

.college-section__head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.college-section__badge {
  flex-shrink: 0;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 15px;
  font-weight: 800;
  color: #fff;
  background: linear-gradient(135deg, #175cc4, #4a9eff);
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(23, 92, 196, 0.35);
}

.college-section__bar {
  width: 3px;
  height: 20px;
  border-radius: 2px;
  background: linear-gradient(180deg, #175cc4, #7ec0ff);
  flex-shrink: 0;
}

.college-section__title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
  flex: 1;
  min-width: 0;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(268px, 1fr));
  gap: 16px;
}

.major-card {
  position: relative;
  background: linear-gradient(155deg, #ffffff 0%, #f9fbfe 48%, #f3f7fc 100%);
  border-radius: 16px;
  border: 1px solid rgba(23, 92, 196, 0.12);
  overflow: hidden;
  transition: box-shadow 0.25s ease, transform 0.25s ease, border-color 0.25s ease;
}

.major-card--rich {
  display: flex;
  flex-direction: column;
}

.major-card:hover {
  box-shadow: 0 14px 40px rgba(23, 92, 196, 0.16);
  transform: translateY(-4px);
  border-color: rgba(23, 92, 196, 0.26);
}

.major-card:hover .major-card__foot-arrow {
  transform: translateX(4px);
  color: #175cc4;
}

.major-card__shine {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #175cc4, #5cadff, #8fd3ff);
  opacity: 0.95;
}

.major-card__deco {
  position: absolute;
  right: -28px;
  top: -28px;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: radial-gradient(circle at center, rgba(23, 92, 196, 0.09), transparent 68%);
  pointer-events: none;
}

.major-card__body {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 18px 16px 12px;
  position: relative;
  z-index: 1;
}

.major-card__avatar {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 800;
  color: #fff;
  line-height: 1;
  background: linear-gradient(145deg, #175cc4 0%, #3d8ee5 55%, #5cadff 100%);
  box-shadow: 0 6px 16px rgba(23, 92, 196, 0.35);
}

.major-card__text {
  flex: 1;
  min-width: 0;
}

.major-card__name {
  margin: 0;
  font-size: 17px;
  font-weight: 650;
  color: #303133;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.major-card__tagline {
  margin: 8px 0 0;
  font-size: 13px;
  color: #909399;
  letter-spacing: 0.02em;
  line-height: 1.4;
}

.major-card__foot {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  margin-top: auto;
  padding: 10px 16px 14px;
  border-top: 1px solid rgba(23, 92, 196, 0.08);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.5), rgba(245, 249, 253, 0.95));
}

.major-card__foot-hint {
  font-size: 14px;
  font-weight: 600;
  color: #175cc4;
}

.major-card__foot-arrow {
  display: inline-flex;
  align-items: center;
  color: #a0c4ee;
  font-size: 16px;
  transition: transform 0.22s ease, color 0.22s ease;
}

.code-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  padding: 6px 12px 6px 10px;
  border-radius: 999px;
  background: linear-gradient(135deg, #f4f8fd 0%, #eef3fa 100%);
  border: 1px solid rgba(23, 92, 196, 0.1);
}

.code-pill__l {
  color: #909399;
  font-weight: 500;
}

.code-pill__v {
  font-family: ui-monospace, 'SF Mono', Menlo, monospace;
  font-weight: 600;
  color: #175cc4;
  letter-spacing: 0.04em;
}

.el-main {
  --el-main-padding: 0px;
}

.h5-wrap {
  min-height: 100vh;
  background: linear-gradient(180deg, #e8f1fb 0%, #f0f5fb 45%, #f4f8fc 100%);
  padding-bottom: 28px;
  /* 与全局 100vw 等问题解耦：防止本页局部撑出整页横向滚动 */
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
}

.h5-banner {
  background: linear-gradient(165deg, #175cc4 0%, #1a6bcf 40%, #3d93ea 100%);
  color: #fff;
  padding: 26px 16px 22px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.h5-banner::after {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(ellipse 80% 60% at 100% 0%, rgba(255, 255, 255, 0.14), transparent 55%);
  pointer-events: none;
}

.h5-eyebrow {
  margin: 0 0 8px;
  font-size: 11px;
  letter-spacing: 0.28em;
  opacity: 0.8;
  position: relative;
  z-index: 1;
}

.h5-title {
  font-size: 24px;
  font-weight: 800;
  letter-spacing: 2px;
  position: relative;
  z-index: 1;
}

.h5-sub {
  margin-top: 8px;
  font-size: 14px;
  opacity: 0.9;
  position: relative;
  z-index: 1;
}

.h5-stats {
  margin-top: 12px;
  font-size: 14px;
  opacity: 0.95;
  position: relative;
  z-index: 1;
}

.h5-stats-dot {
  margin: 0 6px;
  opacity: 0.6;
}

.h5-search {
  padding: 8px 0 0;
  background: #fff;
  max-width: 100%;
  box-sizing: border-box;
}

.h5-search :deep(.van-search) {
  padding-left: 12px;
  padding-right: 12px;
  box-sizing: border-box;
}

.h5-chips-wrap {
  padding: 10px 12px 0;
  overflow: hidden;
}

.h5-chips {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding-bottom: 4px;
  -webkit-overflow-scrolling: touch;
}

.h5-chips::-webkit-scrollbar {
  height: 0;
}

.h5-chip {
  flex-shrink: 0;
  padding: 9px 15px;
  font-size: 13px;
  color: #175cc4;
  background: #fff;
  border: 1px solid rgba(23, 92, 196, 0.2);
  border-radius: 999px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(23, 92, 196, 0.08);
}

.h5-chip--active {
  background: #e8f1fc;
  border-color: #175cc4;
  font-weight: 600;
  color: #134a9e;
}

.h5-body {
  padding: 14px 12px 0;
  min-height: 200px;
  position: relative;
}

.h5-body__empty-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  width: 100%;
  box-sizing: border-box;
  padding: 24px 8px 32px;
}

.h5-college-block {
  margin-bottom: 22px;
  scroll-margin-top: 12px;
}

.h5-college-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 700;
  color: #175cc4;
  padding: 10px 4px 12px;
  margin-bottom: 8px;
  border-bottom: 1px solid rgba(23, 92, 196, 0.12);
}

.h5-college-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  font-size: 12px;
  font-weight: 800;
  color: #fff;
  background: linear-gradient(135deg, #175cc4, #4a9eff);
  border-radius: 8px;
}

.h5-major-card {
  margin-bottom: 10px;
  border-radius: 14px;
  border: 1px solid rgba(23, 92, 196, 0.1);
  background: linear-gradient(155deg, #ffffff 0%, #f7faff 100%);
  box-shadow: 0 4px 18px rgba(23, 92, 196, 0.08);
  transition: box-shadow 0.2s ease, transform 0.2s ease, border-color 0.2s ease;
}

.h5-major-card--rich {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 12px 12px 14px;
}

.h5-major-card--rich:active {
  transform: scale(0.992);
}

.h5-major-card__avatar {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 800;
  color: #fff;
  background: linear-gradient(145deg, #175cc4 0%, #3d8ee5 55%, #5cadff 100%);
  box-shadow: 0 4px 12px rgba(23, 92, 196, 0.32);
}

.h5-major-card__main {
  flex: 1;
  min-width: 0;
}

.h5-major-name {
  font-size: 17px;
  font-weight: 650;
  color: #303133;
  line-height: 1.45;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.h5-major-tagline {
  margin-top: 4px;
  font-size: 13px;
  color: #909399;
  letter-spacing: 0.02em;
  line-height: 1.35;
}

.h5-major-card__cta {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 999px;
  color: #a0c4ee;
  background: rgba(23, 92, 196, 0.06);
  font-size: 16px;
}

.major-card--clickable {
  cursor: pointer;
}

.h5-major-card--clickable {
  cursor: pointer;
}
</style>

<style>
/* v-loading 蒙层挂到元素上，自定义 class 需非 scoped；菊花与内容区垂直水平居中 */
.major-catalog-loading.el-loading-mask,
.major-h5-loading.el-loading-mask {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.major-catalog-loading .el-loading-spinner,
.major-h5-loading .el-loading-spinner {
  position: static !important;
  top: auto !important;
  margin-top: 0 !important;
}
</style>
